import React from 'react'

import { Field, connect } from 'formik'
import { FormValues } from 'donate/types'
import { PlatformNewsletterCheckboxFieldProps } from './types'

export const PlatformNewsletterCheckbox = connect<{}, FormValues>(({ formik }) => {
  if (!formik.values._show_platform_subscription) return null

  return (
    <Field name="newsletter">
      {({ field }: PlatformNewsletterCheckboxFieldProps) => (
        <div className="platform-donations-new-subscribe-to-platform-newsletter mb-3">
          <label className="generic-custom-radio-field w-full mb-0" htmlFor="subscribeToPlatformNewsletter">
            <input type="checkbox" {...field} id="subscribeToPlatformNewsletter" />
            <span className="generic-custom-radio" />
            <div>{i18n.t('donate.platform_newsletter_checkbox.label')}</div>
          </label>
        </div>
      )}
    </Field>
  )
})
